import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createAdverseAction = (payload) => post(baseURL + url.ADVERSE_ACTION, payload);
export const getAdverseActionDetails = (id) => get(`${baseURL + url.ADVERSE_ACTION}/${id}`);
export const updateAdverseAction = (id, payload) => put(`${baseURL + url.ADVERSE_ACTION}/${id}`, payload);
export const deleteAdverseAction = (id) => remove(`${baseURL + url.ADVERSE_ACTION}/${id}`);
